/**
 * Created by Rodrigo Quesada on 25/05/17.
 */
import {Injectable, OnDestroy} from '@angular/core';
import {DEFAULT_INTERRUPTSOURCES, Idle} from '@ng-idle/core';
import {ToastData, ToastOptions, ToastyConfig, ToastyService} from 'ng2-toasty';
import {AuthService} from '../authorization/auth.service';
import {Subscription} from 'rxjs/Subscription';

const IDLE_TIME_S = 1740;
const TIMEOUT_TIME_S = 60;

@Injectable()
export class AutoLogoutService implements OnDestroy {

    private _started = false;

    private _toast?: ToastData;

    // region Subscriptions
    readonly subscriptions: Subscription[] = [];
    // endregion

    constructor(private readonly _idle: Idle,
                private readonly _toastyService: ToastyService,
                private readonly _toastyConfig: ToastyConfig,
                private readonly _authService: AuthService) {
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    start() {
        if (!this._started) {
            this._toastyConfig.theme = 'bootstrap';

            this._idle.setIdle(IDLE_TIME_S);
            this._idle.setTimeout(TIMEOUT_TIME_S);
            this._idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

            this.subscriptions.push(this._idle.onTimeoutWarning.subscribe(countdown => {
                this._refreshToast(countdown);
            }));
            this.subscriptions.push(this._idle.onIdleEnd.subscribe(_ => {
                if (this._toast) this._toastyService.clear(this._toast.id);
            }));
            this.subscriptions.push(this._idle.onTimeout.subscribe(() => this._authService.logout()));

            this.subscriptions.push(this._authService.userIsLoggedIn$.subscribe(loggedIn => {
                if (loggedIn) this._idle.watch();
                else this._idle.stop();
            }));

            this._started = true;
        }
    }

    private _refreshToast(secondsLeft: number) {

        if (!this._toast) {
            let toastOptions: ToastOptions = {
                title: 'Are you still there?',
                msg: this._message(secondsLeft),
                showClose: false,
                timeout: TIMEOUT_TIME_S * 1000,
                onAdd: (toast: ToastData) => this._toast = toast,
                onRemove: _ => this._toast = undefined
            };

            this._toastyService.warning(toastOptions);
        }
        else this._toast.msg = this._message(secondsLeft);
    }

    private _message(secondsLeft: number): string {
        return `Your session will time out in ${secondsLeft} seconds!`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/security/autologout/auto-logout.service.ts